import {BuilderTemplates} from "./builder-templates";

export class BuilderTemplatesMapper {

  public static map(data: any): BuilderTemplates {
    let builderTemplates: BuilderTemplates = new BuilderTemplates();
    builderTemplates.id = data.id;
    builderTemplates.title = data.title;
    builderTemplates.categories = data.template_categories;
    builderTemplates.classificationTags = data.classification_tags;
    builderTemplates.creationDate = data.created_at;
    builderTemplates.demoUrl = data.demo_url ? data.demo_url.replace(/\/$/, "") : "";
    builderTemplates.description = data.description;
    builderTemplates.pagesData = data.pages_data;
    builderTemplates.published = data.published;
    builderTemplates.screenShotUrl = data.screenshots_url ? data.screenshots_url.split(",") : null;
    builderTemplates.desktopScreenShotUrl = builderTemplates.screenShotUrl ? builderTemplates.screenShotUrl[0] : null;
    builderTemplates.mobileScreenShotUrl = builderTemplates.screenShotUrl ? builderTemplates.screenShotUrl[1] : null;
    builderTemplates.slug = data.slug;
    builderTemplates.thumbnail = data.thumbnail;
    builderTemplates.type = data.type;
    builderTemplates.run_url = data.run_url;
    builderTemplates.ever_recreated = data.ever_recreated;

    return builderTemplates;
  }
}
